import * as React from 'react';
import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';
import { useStores } from '../../stores';
import { observer } from 'mobx-react-lite';
import S4ReportsTable from '../../components/s4reports/S4ReportsTable';
import { FieldServiceReport } from '../../domain/FieldServiceReport';
import { ServiceAssignment } from '../../domain/Publisher';

interface Props {
    serviceAssignment: ServiceAssignment | string;
}

const PivotTableTab = observer((props: Props) => {
    const { reportStore } = useStores();
    const [reports, setReports] = React.useState<FieldServiceReport[]>([]);

    React.useEffect(() => {
        reportStore.getPivotByAppointment(props.serviceAssignment, (data: FieldServiceReport[]) => {
            setReports(data);
        });
    }, [reportStore]);

    return (
        <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
            <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
                <S4ReportsTable
                    reports={reports}
                    editable={false}
                    onEdit={() => { }}
                    onDelete={() => { }}
                />
            </Paper>
        </Container>
    );
});

export default PivotTableTab;
